import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { InstitutionGroup } from './InstitutionGroup';
import { Event } from './Event';
import { EVENTS_I_HOST, GROUPS_I_AM_ADMIN_OF } from './SecurityRules';

export interface InstitutionGroupEventRow {
  id: number;
  institution_group_id: number;
  institution_event_id: number;
  created_at: string;
}

export const InstitutionGroupEvent: Entity<InstitutionGroupEventRow> = {
  id: 'InstitutionGroupEvent',
  title: 'Institution Group Event',
  service: 'main',
  rowLabel: (row: InstitutionGroupEventRow) => [row.institution_group_id, row.institution_event_id].join(' / '),
  rowLabelDynamic: (row: InstitutionGroupEventRow) =>
    `<lookup:EventView:${row.institution_event_id}> / <lookup:InstitutionGroup:${row.institution_group_id}>`,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.institution_group_event',
  },
  security: [
    {
      role: 'user',
      action: 'read',
      access: 'conditional',
      condition: `institution_event_id IN ${EVENTS_I_HOST}`,
    },
    {
      role: 'admin',
      action: 'all',
      access: 'conditional',
      condition: `institution_group_id IN ${GROUPS_I_AM_ADMIN_OF}`,
    },
    { role: 'staff', action: 'all', access: 'all' },
  ],
  defaultSort: [['institution_group_id', 'ASC']],
  defaultFilters: [],
  fields: {
    id: {
      seq: 5,
      type: FieldType.Integer,
      label: 'Id',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      autoIncrement: true,
    },
    institution_group_id: {
      seq: 10,
      type: FieldType.Reference,
      label: 'Institution Group',
      listColumn: true,
      refEntity: InstitutionGroup,
    },
    institution_event_id: {
      seq: 15,
      label: 'Event',
      type: FieldType.Reference,
      listColumn: true,
      refEntity: Event,
    },
    created_at: {
      seq: 20,
      label: 'Created At',
      type: FieldType.Datetime,
      persistence: PersistenceType.BackEndManaged,
    },
  },
};
